import { Formik } from "formik";
import React from "react";
import * as yup from "yup";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import SettingLayout from "./settinglayout";

const schema = yup.object({
  company: yup.string().required("Company is required"),
});
const ServiceStatus = ({ activeCompany }) => {
  return (
    <SettingLayout title="Company Info">
      <Formik
        validationSchema={schema}
        onSubmit={console.log}
        initialValues={{
          company: activeCompany?.name,
        }}
        enableReinitialize
      >
        {({ handleSubmit, isValid, isSubmitting }) => (
          <form noValidate onSubmit={handleSubmit} className="w-100 p-5">
            <FormikTextField
              size="lg"
              controlId="company"
              label="Company"
              type="text"
              disabled={true}
              name="company"
              disabled={true}
              className="mb-4"
            />

            <LoaderButton
              block
              type="submit"
              variant="primary"
              size="lg"
              text="Next"
              className="mb-2"
              isLoading={isSubmitting}
              disabled={true || !isValid || isSubmitting}
            >
              Save
            </LoaderButton>
            <div className="font-size-4 pt-4">
              Need help? Email us at{" "}
              <a href="mailto:help@taabl.co">
                <u>help@taabl.co</u>
              </a>
            </div>
          </form>
        )}
      </Formik>
    </SettingLayout>
  );
};

export default ServiceStatus;
